import { useTenantStore } from '@/stores/tenantStore'
import { $api } from '../typedClient'

// Mapping from singular to entity grid endpoint paths
type EntityGridEndpoint =
  | '/crossroads/network/companies/grid'
  | '/crossroads/entity/sites/grid'
  | '/crossroads/entity/tanks/grid'
  | '/crossroads/entity/products/grid'
  | '/crossroads/entity/terminals/grid'

const endpointMapping: Record<string, EntityGridEndpoint> = {
  company: '/crossroads/network/companies/grid',
  counterparty: '/crossroads/network/companies/grid', // Companies and counterparties use the same endpoint
  product: '/crossroads/entity/products/grid',
  terminal: '/crossroads/entity/terminals/grid',
  site: '/crossroads/entity/sites/grid',
  tank: '/crossroads/entity/tanks/grid',
}

export function useCrossroadsEntityGrid(
  entityType: string,
  enabled: boolean = true,
  limit?: number,
) {
  const { selectedTenant } = useTenantStore()
  const endpoint =
    endpointMapping[entityType] ?? '/crossroads/entity/sites/grid'

  return $api.useQuery(
    'get',
    endpoint,
    {
      params: {
        query: typeof limit === 'number' && limit > 0 ? { limit } : {},
      },
    },
    {
      enabled: !!entityType && enabled && !!selectedTenant?.name,
      staleTime: 60000, // Cache for 1 minute
      retry: false, // Don't retry on failure to allow fallback to work quickly
    },
  )
}
